// Global Instructions Rule Applied!
import { FieldConfig } from '../../../core/components/InputManager/types.ts'
import { isRequiredFieldValid } from '../../../core/components/InputManager/utils/formatters.ts'
import { ProspectFields } from './fieldConfigs.ts'
import { AccountRecordFields } from '../../../state_manager/data_models/account_record.ts'

/**
 * Validates required fields for prospect form
 */
export function validateRequiredFields(
  fields: FieldConfig[],
  formValues: Record<string, any>,
  formData: Record<string, any>,
  selectedContacts?: Record<string, any>
): { isValid: boolean; errors: Record<string, string> } {
  const errors: Record<string, string> = {}

  fields.forEach((field) => {
    if (!field.required) return

    const fieldKey = field.key
    let value = formValues[fieldKey] ?? formData[fieldKey]

    // Handle contact fields that are stored in selectedContacts
    if (fieldKey === ProspectFields.contact_accounts__introduced_by) {
      value = selectedContacts?.[fieldKey] ?? selectedContacts?.introduced_by ?? value
    } else if (fieldKey === ProspectFields.contact_accounts__sourced_by) {
      value = selectedContacts?.[fieldKey] ?? selectedContacts?.sourced_by ?? value
    } else if (fieldKey === ProspectFields.contact_prospects__lead) {
      value = selectedContacts?.[fieldKey] ?? selectedContacts?.lead ?? value
    }

    // Handle conditional requirements
    if (fieldKey === ProspectFields.prospects__investor) {
      // Investor is only required if not creating a new investor
      if (formData[ProspectFields.prog__is_new_investor]) {
        return // Skip validation for investor field when creating new investor
      }
    }

    if (fieldKey === AccountRecordFields.accounts__name) {
      // Investor name is only required if creating a new investor
      if (!formData[ProspectFields.prog__is_new_investor]) {
        return // Skip validation for investor name when using existing investor
      }
    }

    // Validate the field value
    if (!isRequiredFieldValid(value)) {
      const fieldLabel = field.label || fieldKey
      errors[fieldKey] = `${fieldLabel} is required`
    }
  })

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  }
}
